import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { Box, MenuItem, Select, TextField } from "@mui/material";

import { PaymentLinksSearchIcon } from "../../../assets/icons/MUI/PaymentIcons";
import RangedDatePicker from "../../../shared/Dates/RangedDatePicker";

const PaymentLinksControl = ({
  searchValue,
  dateRange,
  setDateRange,
  handleChangeText,
  statusValue,
  setStatusValue,
}: {
  searchValue: string;
  dateRange: [Date | null, Date | null];
  setDateRange: Dispatch<SetStateAction<[Date | null, Date | null]>>;
  handleChangeText: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  statusValue: string;
  setStatusValue: Dispatch<SetStateAction<string>>;
}) => {
  const { t } = useTranslation();

  const linkStatusesList = [
    { value: "all", label: t("pages.payment.paymentLinks.all") },
    { value: "expired", label: t("pages.payment.paymentLinks.expired") },
    { value: "open", label: t("pages.payment.paymentLinks.open") },
  ];

  return (
    <Box sx={{ display: "flex", columnGap: "12px" }}>
      <TextField
        value={searchValue}
        onChange={handleChangeText}
        placeholder={t("pages.payment.paymentLinks.search")}
        InputProps={{
          endAdornment: <PaymentLinksSearchIcon style={{ fill: "none", width: "24px", height: "24px" }} />,
          autoComplete: "new-password",
        }}
        variant="outlined"
        sx={{
          width: "320px",
          "& .MuiOutlinedInput-root": {
            padding: "0 14px",
            borderRadius: "8px",
          },
        }}
      />
      <RangedDatePicker dateRange={dateRange} setDateRange={setDateRange} />
      <Select
        value={statusValue}
        onChange={(e) => setStatusValue(e.target.value)}
        label={t("pages.payment.paymentLinks.status")}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
          },
        }}
      >
        {linkStatusesList.map((status) => (
          <MenuItem value={status.value}>{status.label}</MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default PaymentLinksControl;
